/* eslint-disable springload/react/prefer-stateless-function */
/* eslint-disable class-methods-use-this */
/* eslint-disable springload/react/prop-types */

// eslint-disable-next-line springload/import/extensions
import { h, Component } from 'preact';
import { filterHit, formatMatch } from './search-algolia-utils';

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class SearchResultCard extends Component {
    renderSearchMatch(matchedText) {
        return (
            <span
                className="search-results-match"
                // eslint-disable-next-line springload/react/no-danger
                dangerouslySetInnerHTML={{
                    __html: formatMatch(matchedText),
                }}
            />
        );
    }

    renderHit(hit) {
        const matchesToDisplay = filterHit(hit);
        return matchesToDisplay.map(match =>
            this.renderSearchMatch(match.value),
        );
    }

    render() {
        const hit = this.props.hit;
        return (
            <li className={`block block-article t-${hit.objectStyleVariant}`}>
                <a
                    className={`block__link block__link--line-after t-after-color-${hit.objectStyleVariant} u-text-no-link-style`}
                    href={hit.objectURL}
                    title={hit.objectBannerTitle}
                    data-transition-color={hit.objectStyleVariant}
                >
                    <img
                        className="block__image block__image--article"
                        src={`/assets/topic-illustration-${hit.objectStyleVariant}.svg`}
                        alt={`${hit.objectStyleVariant}`}
                    />
                    <div className="block__title">
                        <h2
                            className="block__heading"
                            // eslint-disable-next-line springload/react/no-danger
                            dangerouslySetInnerHTML={{
                                __html: hit._highlightResult.objectBannerTitle
                                    ? hit._highlightResult.objectBannerTitle
                                          .value
                                    : hit.objectBannerTitle,
                            }}
                        />
                    </div>
                    <p className="block__intro">
                        {this.renderHit(hit._highlightResult)}
                    </p>
                </a>
            </li>
        );
    }
}

export default SearchResultCard;
